import type { JSX } from "react";

import { useWorkspaceOAuthCallback } from "./workspaceOAuth/useWorkspaceOAuthCallback";

export function WorkspaceOAuthCallback(): JSX.Element {
  const status = useWorkspaceOAuthCallback();

  return (
    <main className="flex min-h-screen items-center justify-center bg-[#f4efe5] px-6 text-center text-[#172018]">
      <p>{status}</p>
    </main>
  );
}
